"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOTSType = exports.IoTsURI = void 0;
var Either_1 = require("fp-ts/Either");
/**
 *  @since 0.0.1
 */
exports.IoTsURI = 'IoTsURI';
/**
 *  @since 0.0.1
 */
var IOTSType = /** @class */ (function () {
    function IOTSType(type) {
        var _this = this;
        this.type = type;
        this.create = function (a) { return Either_1.map(function (x) { return x; })(_this.type.decode(_this.type.encode(a))); };
    }
    return IOTSType;
}());
exports.IOTSType = IOTSType;
